module.exports = __webpack_public_path__ + "img/nl.94c899ff.svg";